import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

import { connect } from 'react-redux';

import { fetchCampaign } from 'reducers/project/projectActions'

class CampaignSelect extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchCampaign(this.props.project.value);
    }

    handleChange = (campaign) => {
        this.props.handleChange(campaign);
    }

    render() {
        const campaigns = [];
        if (this.props.campaign) {

            campaigns.push({ value: null, label: "Sin Campaña" });
            this.props.campaign.map((campaign) => {
            campaigns.push({ value: campaign.value, label: campaign.label })
            });
        }

        return (
            <OgaSelect
                disabled={this.props.disabled}
                bsSize="small"
                placeholder="Elija una campaña"
                value={this.props.selection}
                onChange={(campaign) => this.handleChange(campaign)}
                options={campaigns}
            />
        )
    }
}

const mapStateToProps = state => ({
    campaign: state.project.campaign
});

export default connect(mapStateToProps, { fetchCampaign })(CampaignSelect);



// WEBPACK FOOTER //
// ./src/components/CampaignSelect/CampaignSelect.jsx